/**
 * Returns the correct API base URL:
 * - In preview/localhost: uses REACT_APP_BACKEND_URL
 * - In production with custom domain (e.g. mevia.mx): uses '' (relative) to avoid CORS
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const isCustomDomain = typeof window !== 'undefined'
  && !window.location.hostname.includes('localhost')
  && !window.location.hostname.includes('preview.emergentagent.com');

export const getApiBaseUrl = () => isCustomDomain ? '' : BACKEND_URL;
export const API_BASE = isCustomDomain ? '' : BACKEND_URL;
